import { render, staticRenderFns } from "./Barn.vue?vue&type=template&id=3700d79e&scoped=true&"
import script from "./Barn.vue?vue&type=script&lang=js&"
export * from "./Barn.vue?vue&type=script&lang=js&"
import style0 from "./Barn.vue?vue&type=style&index=0&id=3700d79e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3700d79e",
  null
  
)

export default component.exports